import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Associated List
function createAssociatedList(params: any) {
    const baseUrl = `/refer/createRefer`;
    return api.create(`${baseUrl}`, params);
}
// update Associated List
function updateAssociatedList(params: any) {
    const baseUrl = '/refer/updRefer';
    return api.create(`${baseUrl}`, params);
}

// get all Associated List
function getAllAssociatedList(params: any) {
    const baseUrl = '/refer/getReferInfo';
    return api.create(`${baseUrl}`, params);
}

// get Associated List
function getAssociatedList(params: any) {
    const baseUrl = '/refer/getReferDtl';
    return api.create(`${baseUrl}`, params);
}

// get getDrList_Inst  List
function getDrListInst(params: any) {
    const baseUrl = '/refer/getDrList_Inst ';
    return api.create(`${baseUrl}`, params);
}

// get User Doctor lists
function getAllDrList(params: any) {
    const baseUrl = '/refer/getAllDrList';
    return api.create(`${baseUrl}`, params);
}

export {
    createAssociatedList,
    updateAssociatedList,
    getAllAssociatedList,
    getAssociatedList,
    getDrListInst,
    getAllDrList,
};
